import keys from 'lodash/keys';
import omit from 'lodash/omit';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

//import get from 'lodash/get';
import cn from 'classnames';
import css from './css.css';
import noop from 'lodash/noop';

import { Box, Button, HStack, List, Popover, Pressable, Text, VStack, } from "~/native-ui"

let propTypes = {
    children: PropTypes.node,
	onExpand: PropTypes.func,
    mode: PropTypes.string.isRequired,
	isExpanded: PropTypes.bool,
	expandButtonProps: PropTypes.shape(),
};

let ownPropNames = keys(propTypes);

export default class PopupList extends Component {
	static propTypes = propTypes;

	static defaultProps = {
		onExpand: noop,
        mode: 'unordered'
	};

	state = {
		expanded: false
	};

	sign = this.props.sign || "+";

	componentDidUpdate(prevProps) {
		if (!!this.props.isExpanded !== !!prevProps.isExpanded) {
			this.setState({ expanded: !!this.props.isExpanded });
		}
	}

    expand = (e, val = true) => {
        e?.stopPropagation();
        e?.preventDefault();
        this.setState({expanded: val});
		
		this.props.onExpand(val);
        return false;
    };

	toggle = () => {
		return this.expand(null, !this.state.expanded)
	}

    ownProps = () => {
    	return omit(this.props,ownPropNames);
	};

	buttonTextStyle = {fontSize: "8", };
	renderTrigger = (props) => {
        let moreCount = React.Children.toArray(this.props.children).length - 1;
		return (
			<Pressable {...props} >
				<Button key="expand-button" alignSelf="flex-start" colorScheme="primary" ghost ml="2" p="2px" px="1" flexGrow="0" flexShrink="0" _text={this.buttonTextStyle} { ...this.props.expandButtonProps } {...props} label={`${this.sign}${moreCount}`} />
			</Pressable>
		)
	}

    renderExpandButton = () => {
		let moreCount = React.Children.toArray(this.props.children).length - 1;
		if (moreCount <= 0) {
			return null;
		}

        return (
			<Popover
				trapFocus
				shouldFlip
				shadow="2"
				isKeyboardDismissable
				isOpen={this.state.expanded}
				onOpen={this.toggle}
				onClose={this.toggle}
				trigger={this.renderTrigger}
			>
				<Popover.Content>
					<Popover.Arrow height={10} width={10} />
					<Popover.Body>
						{this.renderList()}
					</Popover.Body>
				</Popover.Content>
			</Popover>
		)
	};

	renderFirstChildOnly = () => {
		const child = React.Children.toArray(this.props.children)[0];
		if (!child) return null;

		return React.cloneElement(child, {
			...child?.props,
			unstyled: true,
		})
	}

	renderExpand = () => {
		return (
				<Box ml="-8px" maxWidth="100%" flexDirection="row" {...this.ownProps()} flex="1" className={cn(css.liUnstyler, this.props.className)}>
					<VStack key="list" alignSelf="center" flex="1">{this.renderFirstChildOnly()}</VStack>
					{this.renderExpandButton()}
				</Box>
		)
	};


	renderList = () => {
		const childArr = React.Children.toArray(this.props.children),
			  { mode } = this.props;

		const renderEntry = (e) => {
			return e;
		};

		let list = null;

		switch(mode) {
			case 'delimiter':
                list = childArr.map((curr, i) => {
                	let delimiter = (i+1) === childArr.length ? '' : ', ';
                	return <HStack key={`delimiter-${i}`} className={css.liUnstyler}>{curr}<Text>{delimiter}</Text></HStack>;
				});
				list = <Box ml="-8px" maxWidth="100%">{list}</Box>;
                break;
			case 'ordered':
				list = (
					<List.Ordered key="ordered-list" ml="-8px" space={2} ordered {...this.ownProps() } className={cn(this.props.className, css.list)}>
						{childArr}
					</List.Ordered>
				);
				break;
			default:
				list = (
					<List.Unordered key="unordered-list" ml="-8px" space={2} {...this.ownProps()} className={cn(this.props.className, css.list)}>
						{childArr}
					</List.Unordered>
				);
				break;
		}

        return list;
	};

    componentWillReceiveProps = (nextProps) => {
        if(nextProps.children !== this.props.children) {
            this.setState({ expanded: false });
        }
    };

	render() {
		let isExpanded = this.state.expanded || this.props.isExpanded,
			childArr = React.Children.toArray(this.props.children);

		if(!childArr.length) { return null; }

		if(childArr.length > 1) {
			return this.renderExpand();
		}

		return <Box ml="-8px" maxWidth="100%" {...this.ownProps()} className={cn(css.liUnstyler, this.props.className)}>{this.renderFirstChildOnly()}</Box>;
	}
}